import useDataHook from "./useDataHook";
function QuoteGenerator() {
    const [loading, Quote, errors] = useDataHook('/FamousQuote/GetSingleQuote', null);
    return (<>
        {loading ? <div>Loading...Please wait</div> :
            <div ><p>{Quote.quote}</p>
                <span>- {Quote.author}</span></div>}
        {errors && <div>{errors}</div>}
    </>);
}
export default QuoteGenerator;